import { createSlice } from "@reduxjs/toolkit"

export const customerWishlisttSlice = createSlice({
	name: "customerWishList",
	initialState: {
		customerWishList: "",
		errors: [],
	},

	reducers: {
        getCustomerWishList: (state, action) => {
            // console.log(action.payload);
			state.customerWishList = action.payload
		},
		getCustomerAllWishList: (state, action) => {
            // console.log(action.payload);
			state.customerWishList = action.payload
		},
		getErrors: (state, action) => {
            
			state.errors = action.payload
		},
	},
})
export const {getCustomerWishList, getCustomerAllWishList, getErrors} = customerWishlisttSlice.actions

export default customerWishlisttSlice.reducer
